import React, { useEffect, useRef } from "react";
import { Search } from "lucide-react";
import { COLORS } from "../constants/colors";
import { Target, RotateCw } from 'lucide-react';

export const KPIList = ({
  kpis,
  activeKPI,
  onKPIChange,
  searchTerm,
  onSearchChange
}) => {
  const activeItemRef = useRef(null);

  useEffect(() => {
    if (activeItemRef.current) {
      activeItemRef.current.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [activeKPI]);

  return (
    <div className="flex h-full flex-col bg-[#F7F8FA]">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-[#FFFFFF] border-b border-gray-200 px-4 pb-4 shadow-sm">

        <div className="flex items-center justify-between mb-3">
        <h3 className="text-[15px] font-semibold text-gray-800 flex items-center gap-1">
  <Target className="h-5 " />
  KPI List <span className="text-gray-500">({kpis?.length})</span>
</h3>



         {searchTerm && (
            <button
            onClick={() => onSearchChange("")}
            className="text-sm font-medium flex items-center gap-1"
            style={{ color: COLORS.PRIMARY }}
          >
            <RotateCw className="h-5 " />
            Clear
          </button>
          )}
        </div>

        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search KPIs..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-sm bg-gray-50 border border-gray-300 rounded-lg
                       focus:outline-none focus:ring-2"
            style={{ "--tw-ring-color": COLORS.PRIMARY }}
          />
        </div>
      </div>

      {/* KPI Items */}
      <div className="flex-1 overflow-y-auto px-2 py-2 space-y-1 bg-[#F7F8FA]">

        {kpis?.map((kpi, index) => {
          const isActive = activeKPI === kpi;

          return (
            <button
              key={index}
              ref={isActive ? activeItemRef : null}
              onClick={() => onKPIChange(kpi)}
              className={`w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-all uppercase
                ${isActive
                  ? "text-white bg-[#bb1ccc] shadow-sm"
                  : "bg-white text-gray-700 hover:bg-gray-100"
                }`}

            >
              {kpi}
            </button>
          );
        })}
      </div>
    </div>
  );
};
